import React, { ReactElement } from 'react';
import { TLCode } from '../../../common/enums';
import { css } from 'glamor';
import classNames from 'classnames';
import { FormGroup, IFormGroupProps } from '@blueprintjs/core';
import { TranslatedMessage } from '../translation';
import { InputProps } from './basicInputs';
import { Overwrite } from '../../../typings/typings';

interface CommonFormGroupProps extends IFormGroupProps {
  labelFor: string;
  fill?: boolean;
  centerLabelVertically?: boolean;
  children: ReactElement<InputProps & { label?: string }>;
}

export type FormGroupProps = Overwrite<CommonFormGroupProps, { label?: TLCode | JSX.Element }>;

const fillClassName = css({
  '& .bp3-form-content': {
    flex: '1',
    paddingRight: '1px',
  },
});
const labelBold = css({
  '& .bp3-label': {
    fontWeight: 'bold',
  },
});

class GeneralFormGroup extends React.Component<FormGroupProps> {
  getTranslatedValue = (value) => (typeof value === 'number' ? <TranslatedMessage id={value} /> : value);

  getClassName = () => {
    const { fill, className } = this.props;

    return classNames(
      {
        [fillClassName.toString()]: fill,
        // [centerLabelVerticallyClassName.toString()]: centerLabelVertically,
      },
      labelBold.toString(),
      className,
    );
  };

  renderFormGroup = ({ children, ...formGroupProps }: CommonFormGroupProps) => (
    <FormGroup {...formGroupProps} className={this.getClassName()}>
      {React.cloneElement(children, {
        id: formGroupProps.labelFor,
        intent: formGroupProps.intent,
        disabled: formGroupProps.disabled,
      })}
    </FormGroup>
  );
  render() {
    const { label, helperText, ...otherProps } = this.props;

    return this.renderFormGroup({
      ...otherProps,
      label: React.isValidElement(label) ? label : this.getTranslatedValue(label),
      helperText: this.getTranslatedValue(helperText),
    });
  }
}

export default GeneralFormGroup;
